import { render, staticRenderFns } from "./NavbarAdmin.vue?vue&type=template&id=22c536be"
import script from "./NavbarAdmin.vue?vue&type=script&lang=js"
export * from "./NavbarAdmin.vue?vue&type=script&lang=js"
import style0 from "./NavbarAdmin.vue?vue&type=style&index=0&id=22c536be&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports